export enum InvoiceTypes {
  Proforma = 'Proforma',
  Rechnung = 'Invoice'
}
